function initRechargeAutoAdd() {
    try {
        const params = new URLSearchParams(window.location.search);
        const productId = params.get('auto-add');
        if (!productId) return;

        const selector = `[data-rb-item-id="${productId}"]`;
        const MAX_WAIT_MS = 5000;

        const tryAutoAdd = () => {
        const productEl = document.querySelector(selector);
        if (!productEl) return false;

        const qtyInput = productEl.querySelector('input.rb-qty-input');
        const plusBtn = productEl.querySelector('.rb-btn-qty-plus');

        if (plusBtn) {
            plusBtn.click();
        } else if (qtyInput) {
            qtyInput.value = 1;
            qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        productEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        document.documentElement.style.scrollPaddingTop = '160px';

        return true;
        };

        if (tryAutoAdd()) return;

        const observer = new MutationObserver(() => {
        if (tryAutoAdd()) {
            observer.disconnect();
            clearTimeout(timeoutId);
        }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        const timeoutId = setTimeout(() => {
        observer.disconnect();
        }, MAX_WAIT_MS);
    } catch (e) {
        console.warn('Recharge auto-add failed:', e);
    }
}

document.addEventListener('DOMContentLoaded', initRechargeAutoAdd);

async function addToCart(variantId, qty) {
    const config = {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
        }
    };
    let formData = new FormData();

    formData.append('id', variantId);
    formData.append('quantity', qty);

    config.body = formData;
    await fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
            if (response.status) {
                return;
            }
        })
        .catch((e) => {
            console.error(e);
        });
}

async function addOfferItemToCart(variantId, multipleVariants) {
    try {
        const data = await fetch("/cart.js")
            .then((res) => res.json())

        if (multipleVariants) {
            const filteredIds = data.items.filter(item => item.variant_id === parseInt(variantId[0]) || item.variant_id === parseInt(variantId[1]));
            
            if (filteredIds.length === 2) {
                return
            }
        } else {
            const item = data.items.find(item => item.variant_id === variantId)

            if (item) {
                return
            }
        }

        if (multipleVariants) {
            console.log(`multipleVariants not supported (value ${variantId})`)
        } else {
            await addToCart(variantId, 1);
        }

    } catch(err) {
        console.error("Unable to add item to cart", err)
    }
}

const saleObj = {
    // WIR10810: 40457707061320
}

async function checkForPromoItem(event) {
    const itemId = localStorage.getItem("free_bottle_item");
    if (itemId) {
        if (Object.values(saleObj).includes(parseInt(itemId))) {
            await addOfferItemToCart(itemId);
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
            }));
    }
    }
}

async function getItemParam() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    //console.log(urlParams.has("item"));
    if (!urlParams.has("item")) {
        return
    }

    const tmpIds = urlParams.get("item").trim().split(",")
    if (tmpIds.length === 2) {
        const variantIds = tmpIds.map(sku => saleObj[sku])
        localStorage.setItem("free_bottle_item", variantIds.join(","))
        await addOfferItemToCart(variantIds, true)
        return
    }

    const variantId = saleObj[urlParams.get("item").trim()];
    if (variantId) {
        console.log(`would like to add ${variantId}`);
        localStorage.setItem("free_bottle_item", variantId)
        await addOfferItemToCart(variantId)
    }
}

document.addEventListener('DOMContentLoaded', getItemParam);
document.addEventListener('cart:item-added', checkForPromoItem);
document.addEventListener('line-item:change:end', checkForPromoItem);

// tooltip js 
const initiateTooltip = () => {
  const isMouse = window.matchMedia('(pointer: fine)').matches;
  const tooltips = document.querySelectorAll('.tooltip-container');
  const productDrawerContent = document.querySelector("#Product-Drawer-Content");
  tooltips.forEach((tooltip) => {
    if (isMouse) {
      tooltip.addEventListener('mouseenter', (event) => {
        event.stopPropagation();
        if (tooltip.classList.contains('show')) {
          tooltip.classList.remove('show');
        } else {
          tooltip.classList.add('show');
        }

        productDrawerContent.classList.add("tooltip");

      });
      tooltip.addEventListener('mouseleave', (event) => {
        event.stopPropagation();
        productDrawerContent.classList.remove("tooltip");
        tooltip.classList.remove('show');
      });
    } else {
      tooltip.addEventListener('click', (event) => {
        event.stopPropagation();
        if (tooltip.classList.contains('show')) {
          tooltip.classList.remove('show');
        } else {
          tooltip.classList.add('show');
        }
      });
      document.addEventListener('click', (event) => {
        tooltips.forEach((tooltip) => {
          tooltip.classList.remove('show');
        });
      });
    }
  });
}

const initiateYotpo = () => {
    if(window.yotpoWidgetsContainer) {
        window.yotpoWidgetsContainer.initWidgets();
    }
}

document.addEventListener('DOMContentLoaded', initiateTooltip);
document.addEventListener('quick-view:open', initiateTooltip);

const sectionsToRender = [
    {
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form',
    },
    {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer',
    },
    {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count',
    },
];

const getSections = async () => {
    try {
        const response = await fetch(`/?sections=${sectionsToRender.map((section) => section.section).join(',')}`);
        const data = await response.json();
        return data;
    } catch (e) {
        console.error('Error while fetching cart sections:', e);
    }
    return null;
};

const getSectionInnerHTML = (html, selector = '.shopify-section') => {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
};

document.addEventListener('rebuy.add', async (event) => {
    console.log(`rebuy.add being handled`);
    const newSections = await getSections();
    sectionsToRender.forEach((section) => {
        if (!document.getElementById(section.id)) {
            return;
        }
        const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = getSectionInnerHTML(newSections[section.section], section.selector);
        if (section.id === 'Cart-Drawer') {
            document.getElementById('Cart-Drawer')?.notesToggle();
            document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
            new Cart().renderContents(newSections);
        }
    });
    document.getElementById('Cart-Drawer').classList.add('active');
    document.body.classList.add('open-cart');
    document.body.classList.add('open-cc');
    document.dispatchEvent(new Event('cart:item-added'));
});

const rebuyProductToggles = [];
const loadProductToggles = (product, strikethroughPrice) => {
    let price = product.selected_variant.price;
    if (product.product_type.toLowerCase() === 'bottle' && !product.tags.includes('no-strikethrough')) {
        price = parseFloat(strikethroughPrice);
    }
    rebuyProductToggles.push({
        id: product.id,
        price: price,
        selected: true,
        oos: product.selected_variant.inventory_quantity <= 0,
    });
};

const toggleProduct = (productId, selected) => {
    for (let ii = 0; ii < rebuyProductToggles.length; ii++) {
        const product = rebuyProductToggles[ii];
        if (product.id == productId) {
            product.selected = selected;
            break;
        }
    }
};

const updateTotal = (rebuyContainer) => {
    let total = 0;
    rebuyProductToggles
        .filter((product) => product.selected)
        .forEach((product) => {
            if (!product.oos) {
                total += product.price;
            }
        });
    const atcButton = rebuyContainer.querySelector('.rebuy-bundle__actions-buttons button');
    if (total === 0) {
        atcButton.setAttribute('disabled', true);
    } else {
        atcButton.removeAttribute('disabled');
    }
    rebuyContainer.querySelector('.fg-price').innerText = `$${total}`;
};

document.addEventListener('rebuy.ready', async (event) => {
    // check if we're actually in the right rebuy element. This event fire on all rebuy widgets on the page
    const rebuyContainerCheck = event.detail.widget.element.querySelector('.fg-rebuy-bought-together');
    if (!rebuyContainerCheck) {
        return;
    }

    const rebuyContainer = document.querySelector('.fg-rebuy-bought-together');
    const strikethroughPrice = rebuyContainer.dataset.strikethroughPrice;
    const containerProducts = rebuyContainer.querySelectorAll('.fg-rebuy-product-card');
    const strikethroughActive = rebuyContainer.dataset.strikethroughActive === 'true';
    if (!strikethroughActive) {
        return;
    }

    // load the rebuy products into an array for tracking what products are selected
    const rebuyProducts = event.detail.widget.data.products;
    rebuyProducts.forEach((product) => {
        loadProductToggles(product, strikethroughPrice);
    });
    updateTotal(rebuyContainer);

    containerProducts.forEach((product) => {
        product.querySelector('.rebuy-checkbox').addEventListener('change', (checkEvent) => {
            checkEvent.stopPropagation();
            const target = checkEvent.target;
            const cardContainer = target.closest('.fg-rebuy-product-card');
            const productId = cardContainer.dataset.productId;
            if (target.checked) {
                toggleProduct(productId, true);
            } else {
                toggleProduct(productId, false);
            }
            updateTotal(rebuyContainer);
        });

        const productPricing = rebuyProductToggles.find((item) => item.id == product.dataset.productId);
        product.querySelector('.product-price .price').innerText = `$${productPricing.price}`;
    });
});

function initBundleToggles() {
	const cartDrawer = document.getElementById('Cart-Drawer');
	if (!cartDrawer) return;
	
    // gets each of the product cart items
	const cartItems = cartDrawer.querySelectorAll('.product-cart-item');
	
	cartItems.forEach(cartItem => {
		const toggle = cartItem.querySelector('[data-bundle-toggle]');
		const contentElement = cartItem.querySelector('.bundle-contents-details');
		
		if (!toggle || !contentElement) {
			return;
		}
		
		toggle.addEventListener('click', function() {
            const textElement = toggle.querySelector('.bundle-toggle-text');
            
            toggle.classList.toggle('is-expanded');
            contentElement.classList.toggle('is-hidden');
            
            if (textElement) {
                textElement.textContent = toggle.classList.contains('is-expanded') 
                    ? 'Hide Bundle Contents' 
                    : 'View Bundle Contents';
            }
		});
		
	});
}

document.addEventListener('DOMContentLoaded', initBundleToggles);
document.addEventListener('cart:item-added', initBundleToggles);
document.addEventListener('line-item:change:end', initBundleToggles);

const here = 'is a string';